// assets
import { IconBuildingBridge, IconBuildingCommunity, IconTractor, IconBucket, IconPlug, IconSchool } from '@tabler/icons-react';

// constant
const icons = {
    IconBuildingBridge,
    IconBuildingCommunity,
    IconTractor,
    IconBucket,
    IconPlug,
    IconSchool
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const manzini = {
    id: 'manzini',
    title: 'MANZINI',
    caption: 'Manzini',
    type: 'group',
    children: [
        {
            id: 'dashboard-manzini',
            title: 'Dashboard',
            type: 'item',
            url: '/civils/dashboard/manzini',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'project-overview',
            title: 'Project Overview',
            type: 'collapse',
            icon: icons.IconBuildingBridge,

            children: [
                {
                    id: 'lowLevelCrossing',
                    title: 'Low Level Crossings',
                    type: 'item',
                    url: '/civils/manzini/low-level-crossing',
                    target: false
                },
                {
                    id: 'footbridges',
                    title: 'Foot Bridges',
                    type: 'item',
                    url: '/civils/manzini/foot-bridges',
                    target: false
                },
                {
                    id: 'roads',
                    title: 'Roads',
                    type: 'item',
                    url: '/civils/manzini/roads',
                    target: false
                },
                {
                    id: 'halls',
                    title: 'Commuinity Halls',
                    type: 'item',
                    url: '/civils/manzini/community-halls',
                    target: false
                }
            ]
        }
    ]
};

export default manzini;
